var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{attrs:{"width":_vm.scene.width,"height":_vm.scene.height}})}
var staticRenderFns = []

export { render, staticRenderFns }